import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { DentalService } from '../../_service/dental.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {formatDate} from '@angular/common';
import {UserList, TreatmentList, MachineList, UserResponse, TreatmentResponse, MachineResponse, LeadScanResponse, UpdateScanFormResponse, HospitalList, HospitalResponse, UpdateScanPaymentFormResponse } from 'src/app/_model/dental.model';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { interval } from 'rxjs';
declare var $: any;
@Component({
  selector: 'app-scan-book',
  templateUrl: './scan-book.component.html',
  styleUrls: ['./scan-book.component.css']
})

export class ScanBookComponent implements OnInit {
  @ViewChild('hospitalSearch') hospitalSearchElement: ElementRef;
  @ViewChild('treatmentSearch') treatmentSearchElement: ElementRef;
  @ViewChild('ownerSearch') ownerSearchElement: ElementRef;
  @ViewChild('planUploadFile') planUploadElement: ElementRef;
  @ViewChild('sofFilledUploadFile') sofFilledUploadElement: ElementRef;

  ScanForm: FormGroup; bds: UserList[];bds_copy: UserList[];treatments: TreatmentList[];treatments_copy: TreatmentList[];machineList: MachineList[];scanProUser: UserList[];submitted:boolean=false;hospitals: HospitalList[];hospitals_copy: HospitalList[];invalidName:boolean=false;invalidTreatment:boolean=false;invalidBd:boolean=false;showAddressArea:boolean=false;loading:boolean=false;lead_id:string;dataLoaded:boolean=false;scanId:any;showHospital:boolean=false;ScanUpdateForm: FormGroup;scanStatusPaymentId:number=0;submittedpayment:boolean=false;loadingPayment:boolean=false;paymentdataLoaded:boolean=false;s3url='';doc_type:string='';doc_file:string='';selectedFiles=[];uploading:boolean=false;allUploads=[];generate_plan_counter:boolean=false;total_generate_plan_docs:number=0;aligner_duration_counter:number=0;upper_aligners_counter:number=0;lower_aligners_counter:number=0;mail_sending:boolean=false;mail_send_btn_plan_generate:number=0;myrole:string;userId:string;production_status_tab:boolean=false;loadingProductionStatus:boolean=false;production_status_submitted:boolean=false;balance_amt:number = 0;patient_share_on:number=0;history_loading:boolean=true;history_loaded:boolean=false;updatedLodData=[];sub_rca_arr=[];google_link_share_on:number=0;timeslotsList=[];clinic_address='';
  type_Clinic:boolean=true;

  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;fileDeleting:boolean = false;
  fileDeletingLoader:boolean = false;
  odsDocsDeletingLoader:boolean=false;

  plan_doc_type:string='';plan_share_type:string='';plan_doc_file:string='';planselectedFiles=[];planuploading:boolean=false;PlanallUploads=[];disableSelect:any = []; hideOtpButton = []; showresenOtpButton = []; showsubmitOtpButton = []; showOtpVerified = []; showotpBox = [];
  share_type_select:string='';share_type_array = [];isCMAccess:string;
  base64textString:any;ScanPlanForm: FormGroup;ScanProductionStatusForm: FormGroup;sof_filled_doc_file:string='';ortho_user=[];ortho_user_copy=[];ods_documents=[];new_scan:any;trust_align:any;send_download_type:any='';type_validator_drop=false; email_loading: boolean = false;
  payment_loading:boolean=false;payment_email_loading: boolean = false;filter_plan_lab_list:any='';filter_plan_appt_type:any='';filter_plan_share_type:any;plan_doc_loading:boolean=false;send_download_lab_list:any;send_download_appointment_type:any;appointment_type_lab_arr=[];scan_type_lab_arr=[];

  constructor(private dentalapi:DentalService,private leadapi:LeadsService,private sharedapi:SharedService,private formBuilder: FormBuilder,private route:ActivatedRoute, private router: Router,private activatedRoute: ActivatedRoute, private elem: ElementRef) { 
    let vaildEmailAddress = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

    this.ScanForm = this.formBuilder.group({ 
      'patient_name' : [null,Validators.required],
      'mobile' : [null,Validators.required],
      'patient_age' : [null,Validators.required],
      'gender' : [null,Validators.required],
      'email': [null, Validators.compose([Validators.pattern(vaildEmailAddress),Validators.required])],
      'treatment_id' : [null, Validators.required],
      'scan_machine' : [null, Validators.required],
      'user_id' : [null, Validators.required],
      'scan_pro_user_id': [null],
      'visit_type' : [null, Validators.required],
      'scan_address' :[null],
      'clinic_type' :[null],
      'hospital_id' : [null],
      'appointment_type' :[1,Validators.required],
      'appointment_datetime' : [null, Validators.required],
      'time_slots':[null, Validators.required],
      'status':[null,Validators.required],
      'lead_id':[null],
      'reference_type':[null],
      'google_location':[null],
      'fb_lead_id':[null],
      'lead_source':[null],
      'lead_created_at':[null]
      
    });

    this.ScanUpdateForm = this.formBuilder.group({
      'scan_status' : [null, Validators.required],
      'scan_done_date' : [null],
      'orthodontist_user_id':[null],
      'document_upload_date' : [null],
      'no_scan_reason' : [null],
      'payment_status' : [null],
      'convert_type' : [null],
      'any_other_dental' : [null],
      'transaction_id' : [null],
      'no_payment_reason' : [null],
      'rca' : [null],
      'sub_rca' : [null],
      /* 'payment_mode' :[null], */
      'package_price':[0],
      'discount_price':[0],
      'billed_amt':[0],
      'payment_datetime':[0],
      /* 'received_amt':[null], */
      'google_form_link':[null],
      'patient_category':[null],
      'offer_given':[null],
      'gst_amount':[0],
      'after_gst_billed_amt':[0],
      'balanced_amount':[0],
      'receivedAmtResources': this.formBuilder.array([]) ,
      'fb_lead_id':[null],
      'lead_source':[null],
      'lead_created_at':[null]
     
    });

    this.ScanPlanForm = this.formBuilder.group({
      'plan_generate' : [Validators.required],
      'plan_no_reason' : [null],
      'plan_doc_type' : [null],
      'plan_share_type' : [null],
      'plan_doc_file' :[null],
      'aligners_duration' :[null],
      'upper_aligners' :[null],
      'lower_aligners' :[null],
      'pre_treatment_procedure': [false],
      'pre_delivery_procedure': [false],
      'pre_treatment_procedure_remarks' :[null],
      'pre_delivery_procedure_remarks' :[null],
      'other_information':[null],
      'upper_aligners_725' :[null],
      'lower_aligners_725' :[null],
      'pre_treatment_procedure_remarks_725' :[null],
      'other_information_725':[null],
      'upper_aligners_726' :[null],
      'lower_aligners_726' :[null],
      'pre_treatment_procedure_remarks_726' :[null],
      'other_information_726':[null]
    })

    this.ScanProductionStatusForm = this.formBuilder.group({
      'approval_received' : [null, Validators.required],
      'approval_received_date': [null],
      'approval_received_reason' : [null],
      'sof_filled_document_type' : [null],
      'sof_filled_doc_file' : [null],
      'send_to_production' : [null],
      'send_to_production_on' :[null],
      'aligner_received' :[null],
      'aligner_dispatched_date' :[null],
      'aligner_delivery_date' :[null],
      'tracking_id' :[null],
      'aligner_received_on' :[null],
      'clinic_visit_required' :[null],
      'clinic_visit_required_on' :[null],
      'clinic_visit_hospital' :[null],
      'upper_aligner_received' :[null],
      'remaining_upper_aligner' :[null],
      'lower_aligner_received' :[null],
      'remaining_lower_aligner' :[null],
      'retainer_received' :[null],
      'retainer_dispatched' :[null],
      'pre_treatment_complete_date' :[null],
      'aligner_usages_started_date' :[null]
      
    })

    
   
  }
    get f() { return this.ScanForm.controls; }
    get g() { return this.ScanUpdateForm.controls; }
    get h() { return this.ScanPlanForm.controls; }
    get p() { return this.ScanProductionStatusForm.controls; }

    ngOnInit(): void {
      this.sharedapi.getRole();this.getbds();
      this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
      this.isCMAccess = localStorage.getItem('CMAccess');
      this.userId = localStorage.getItem('loginuserId');

      this.getTreatment();this.getbds();this.getMachine();this.getScanProUser();
      // this.getHospital();
      this.lead_id = this.route.snapshot.paramMap.get("lead_id");
      this.scanId = this.route.snapshot.paramMap.get("scan_id");
      this.getLeadScanFormData();
      this.s3url = localStorage.getItem('s3url');  
      /* this.getTimeslots(); */
      this.getOrthodontistUser();
      if (this.scanId) {
        this.getOdsScanDocs();
      }
    }

    onValChange(val){
      
    }

    calculate_gst_with_package_price(){
      var package_price = this.ScanUpdateForm.get('package_price').value;
      var discount_price = this.ScanUpdateForm.get('discount_price').value;
      var tot_amount = package_price - discount_price;
      this.ScanUpdateForm.patchValue({
        'billed_amt':tot_amount,
      });
      this.calculate_gst();
    }

    calculate_gst(){
      var total_amt = this.ScanUpdateForm.get('billed_amt').value;
      if(total_amt){
        var gst_billed_amount = (total_amt/1.12).toFixed(2);
        var gst_amount = (total_amt.toFixed(2) - Number(gst_billed_amount));
        this.ScanUpdateForm.patchValue({
          'gst_amount':gst_amount.toFixed(2),
          'after_gst_billed_amt':gst_billed_amount,
        }) 
      }else{
        this.ScanUpdateForm.patchValue({
          'gst_amount': 0,
          'after_gst_billed_amt': 0,
        })
      }
      this.get_total_receive_amount();
    }

    addUpdatePlanDocs(){
      if (this.ScanPlanForm.invalid) {
       return;
      }
      this.planuploading = true;
      this.ScanPlanForm.value.scan_book_id= this.scanId; 
      this.ScanPlanForm.value.lead_id= parseInt(this.lead_id); 
      this.dentalapi.uploadPlanFile(this.ScanPlanForm.value)
      .subscribe((data:any) => {
          this.planuploading = false;
          this.uploading = false;
          if(data.status)
          {
            
            this.sharedapi.presentToast(data.msg);
            this.planUploadElement.nativeElement.value = "";
            this.ScanPlanForm.patchValue({
              'plan_share_type':'',
              'plan_doc_type':''
            });
            this.getLeadScanFormData();
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error => 
          {
             
              this.sharedapi.checkError(error);
          });
    }

    
    selectPlanFile(event)
    {
        let file = event.target.files.item(0);
        this.ScanPlanForm.patchValue({
          plan_doc_file: file
        });
    }

    // selectPlanFile(event)
    // {
      
    //     if(this.ScanPlanForm.controls['plan_doc_type'].value!=null)
    //     {
    //       let file = event.target.files.item(0);
    //       const formData = new FormData();  
    //       formData.append('upload_type',this.plan_doc_type)
    //       formData.append('file', file); 
    //       this.ScanPlanForm.value.scan_book_id= this.scanId; 
    //       this.ScanPlanForm.value.lead_id= parseInt(this.lead_id); 
    //       this.dentalapi.uploadPlanFile(this.ScanPlanForm.value,formData)
    //         .subscribe((data:any) => {
    //             this.uploading = false;
    //             if(data.status)
    //             {
    //                 this.sharedapi.presentToast('File uploaded Successful');
    //                 this.getLeadScanFormData();
    //             }
    //             else
    //             {
    //                 this.sharedapi.presentToast(data.msg);
    //             }
    //           }, error => 
    //             {
                   
    //                 this.sharedapi.checkError(error);
    //             });

            
    //     }else{
    //       console.log("calse2")
    //         this.sharedapi.presentToast('Please select Document Type');
    //     }
    // }

    async selectFile(event)
    {
        if(this.doc_type!=undefined)
        {
            this.uploading = true;
            const formData = new FormData(); 
            formData.append('upload_type',this.doc_type); 
            this.selectedFiles = event.target.files;
            for (var i = 0; i < this.selectedFiles.length; i++) {
              if(this.doc_type=='1'){
                
                var fileExtension = this.selectedFiles[i].name.substr((this.selectedFiles[i].name.lastIndexOf('.') + 1));
                if(fileExtension!='stl'){
                  this.sharedapi.presentToast('Please select Stl file');
                  this.uploading = false;
                  return false;
                }

                var file = new File([new Blob()], this.selectedFiles[i].name, {type:"model/stl"});
                formData.append("file[]", file);
              }else{
                formData.append("file[]", this.selectedFiles[i]);
              } 
              
            }
            
            /* await this.dentalapi.uploadScanFile(this.scanStatusPaymentId,this.lead_id,formData) */
            await this.dentalapi.uploadScanFile(this.scanId,this.lead_id,formData)
            .subscribe((data:any) => {
                this.uploading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('File uploaded Successful');
                    this.getLeadScanFormData();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
              }, error => 
                {
                   
                    this.sharedapi.checkError(error);
                });
            
        }else{
            this.sharedapi.presentToast('Please select Document Type');
        }
    }

    addRemoveValidator(type,event){
      if(type=='1'){
        if(event==1){
          this.ScanUpdateForm.controls['payment_status'].setValidators(Validators.required);
          this.ScanUpdateForm.controls['scan_done_date'].setValidators(Validators.required);
          this.ScanUpdateForm.controls['patient_category'].setValidators(Validators.required);
          this.ScanUpdateForm.controls['offer_given'].setValidators(Validators.required);
          this.ScanUpdateForm.controls['no_scan_reason'].setValidators(null);
          this.ScanUpdateForm.controls['rca'].setValidators(null);
          this.ScanUpdateForm.controls['sub_rca'].setValidators(null);
        }else{
          this.ScanUpdateForm.controls['payment_status'].setValidators(null);
          this.ScanUpdateForm.controls['scan_done_date'].setValidators(null);
          this.ScanUpdateForm.controls['patient_category'].setValidators(null);
          this.ScanUpdateForm.controls['offer_given'].setValidators(null);
          this.ScanUpdateForm.controls['no_scan_reason'].setValidators(Validators.required);
          this.ScanUpdateForm.controls['rca'].setValidators(Validators.required);
          this.ScanUpdateForm.controls['sub_rca'].setValidators(Validators.required);
        }
      }else{
          if(event==1){
            this.ScanUpdateForm.controls['no_payment_reason'].setValidators(null);
            this.ScanUpdateForm.controls['payment_datetime'].setValidators(Validators.required);
          }else{
            this.ScanUpdateForm.controls['no_payment_reason'].setValidators(Validators.required);
            this.ScanUpdateForm.controls['payment_datetime'].setValidators(null);
          }
      }
      this.ScanUpdateForm.controls['payment_status'].updateValueAndValidity();
      this.ScanUpdateForm.controls['scan_done_date'].updateValueAndValidity();
      this.ScanUpdateForm.controls['patient_category'].updateValueAndValidity();
      this.ScanUpdateForm.controls['offer_given'].updateValueAndValidity();
      this.ScanUpdateForm.controls['payment_datetime'].updateValueAndValidity();
      this.ScanUpdateForm.controls['no_scan_reason'].updateValueAndValidity();
      this.ScanUpdateForm.controls['rca'].updateValueAndValidity();
      this.ScanUpdateForm.controls['sub_rca'].updateValueAndValidity();
      this.ScanUpdateForm.controls['no_payment_reason'].updateValueAndValidity();
    }

    getSubRCA(event)
    {
      if(event=='1' || event=='5'){
        this.sub_rca_arr = [{'id':1, 'name':'Other'}];
      } else if(event=='2'){
        this.sub_rca_arr = [{'id':2, 'name':'Physically not well'},{'id':3, 'name':'Customer Not available'},{'id':4, 'name':'Scanner Issue'}];
      } else if(event=='3'){
        this.sub_rca_arr = [{'id':5, 'name':'Customer Cancel'},{'id':6, 'name':'Customer Refused'},{'id':7, 'name':'Cancel by Counsellor'},{'id':8, 'name':'Cancel By Pro'},{'id':9, 'name':'Denied Pro'},{'id':13, 'name':'Booked by Underage'},{'id':14, 'name':'Wrong Booking'},{'id':15, 'name':'Fake Booking'}];
      } else if(event=='4'){
        this.sub_rca_arr = [{'id':10, 'name':'Travel Distance High'},{'id':11, 'name':'Office Boy Not Reached On Time'},{'id':12, 'name':'Last appointment Was Delay'}];
      } else {
        this.sub_rca_arr = [];
      }
    }

    showAddressBox(event){
      if(event.value==1 || event.value==3){
        this.ScanForm.controls['scan_address'].setValidators(Validators.required);
        this.ScanForm.controls['hospital_id'].setValidators(null);
      }else{
        this.ScanForm.controls['scan_address'].setValidators(null);
        this.ScanForm.controls['hospital_id'].setValidators(Validators.required);
      }
      this.ScanForm.controls['scan_address'].updateValueAndValidity();
    }

    addUpdateScanPayment(){
      this.submittedpayment = true;
      this.loadingPayment = true;
      if (this.ScanUpdateForm.invalid) {
        this.loadingPayment = false;
       return;
      }
      if(this.scanStatusPaymentId){
        this.ScanUpdateForm.value.id = this.scanStatusPaymentId;
        this.ScanUpdateForm.value.scan_book_id= this.scanId; 
        this.ScanUpdateForm.value.lead_id= parseInt(this.lead_id); 
        this.dentalapi.updatePaymentScanBook(this.ScanUpdateForm.value).subscribe((data:UpdateScanPaymentFormResponse) => {
          this.submittedpayment = false;
          this.loadingPayment = false;
          if(data.status)
          {
            this.scanStatusPaymentId = data.scanId;
            if(this.ScanUpdateForm.value.scan_status == 1) {
              this.generate_plan_counter = true;
            }else{
              this.generate_plan_counter = false;
            }
            this.sharedapi.presentToast(data.msg);
            window.location.reload();
          }else{
            this.sharedapi.presentToast(data.msg);
          }
        }, error => 
        {
          this.sharedapi.checkError(error);
        });
      }else{
        this.ScanUpdateForm.value.scan_book_id= this.scanId; 
        this.ScanUpdateForm.value.lead_id= parseInt(this.lead_id); 
        this.dentalapi.addPaymentScanBook(this.ScanUpdateForm.value).subscribe((data:UpdateScanPaymentFormResponse) => {
          this.submittedpayment = false;
          this.loadingPayment = false;
          if(data.status)
          {
            this.scanStatusPaymentId = data.scanId;
            if(this.ScanUpdateForm.value.scan_status == 1) {
              this.generate_plan_counter = true;
            }else{
              this.generate_plan_counter = false;
            }
            this.sharedapi.presentToast(data.msg);
            window.location.reload();
          }else{
            this.sharedapi.presentToast(data.msg);
          }
        }, error => 
        {
          this.sharedapi.checkError(error);
        });
      }
    }

    selectSofFIlledFile(event)
    {
        let file = event.target.files.item(0);
        this.ScanProductionStatusForm.patchValue({
          sof_filled_doc_file: file
        });
    }

    addUpdateProductionStatus() {
      this.loadingProductionStatus = true;
      this.production_status_submitted = true;
      if (this.ScanProductionStatusForm.invalid) {
        this.loadingProductionStatus = false;
       return;
      }

      if(this.scanId && this.scanId!='0'){
        this.ScanProductionStatusForm.value.id= this.scanId; 
        this.dentalapi.updateScanBookForProductionStatus(this.ScanProductionStatusForm.value)
          .subscribe((data:UpdateScanFormResponse) => {
              this.production_status_submitted = false;
              this.loadingProductionStatus = false;
              if(data.status)
              {
                this.sharedapi.presentToast(data.msg);
                this.sofFilledUploadElement.nativeElement.value = "";
                this.ScanProductionStatusForm.patchValue({
                  'sof_filled_document_type':'',
                  'sof_filled_doc_file':''
                });
                this.getLeadScanFormData();
              }
              else
              {
                  this.sharedapi.presentToast(data.msg);
              }
            }, error => 
            {
                this.sharedapi.checkError(error);
            });
      }
    }
    
    updateScanForm(){
      this.submitted = true;
      this.loading = true;
        // stop here if form is invalid
        if (this.ScanForm.invalid) {
            this.loading = false;
            return;
        }
        this.ScanForm.value.lead_id= parseInt(this.lead_id); 
        if(this.scanId && this.scanId!='0'){
          this.ScanForm.value.id= this.scanId; 
          this.dentalapi.updateScanBook(this.ScanForm.value)
          .subscribe((data:UpdateScanFormResponse) => {
              this.submitted = false;
              this.loading = false;
              if(data.status)
              {
                this.sharedapi.presentToast(data.msg);
                this.getLeadScanFormData();
              }
              else
              {
                  this.sharedapi.presentToast(data.msg);
              }
            }, error => 
            {
                this.sharedapi.checkError(error);
            });
        }else{
          this.dentalapi.addScanBook(this.ScanForm.value)
          .subscribe((data:UpdateScanFormResponse) => {
              this.submitted = false;
              this.loading = false;
              if(data.status)
              {
                this.sharedapi.presentToast(data.msg);
                setTimeout(() => {
                  this.router.navigate(["scan-booked-list"]);
                }, 2000);
              }
              else
              {
                  this.sharedapi.presentToast(data.msg);
              }
            }, error => 
            {
                this.sharedapi.checkError(error);
            });
        }
    }

    setSearchValue(type){
      if(type=='treatment'){
        this.treatmentSearchElement.nativeElement.focus();
        this.treatmentSearchElement.nativeElement.value = '';
        this.treatments= this.treatments_copy;
      }else if(type=='lead_owner'){
        this.ownerSearchElement.nativeElement.focus();
        this.ownerSearchElement.nativeElement.value = '';
        this.bds= this.bds_copy;
      }else if(type=='hospital'){
        this.hospitalSearchElement.nativeElement.focus();
        this.hospitalSearchElement.nativeElement.value = '';
        this.hospitals= this.hospitals_copy;
      }else if(type=='orthodontist_user'){
        this.hospitalSearchElement.nativeElement.focus();
        this.hospitalSearchElement.nativeElement.value = '';
        this.ortho_user= this.ortho_user_copy;
      }
    }

    searchOnSelect(searchtText: string, type){
        if(type == 'treatment'){
          this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else if(type == 'lead_owner'){
          this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'hospital'){
          this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'orthodontist_user'){
          this.ortho_user = this.sharedapi.searchData(searchtText, this.ortho_user_copy, "name");
        }
    }

    async fetchReceivedAmountData()
    {
        this.dentalapi.fetchReceivedAmount(this.lead_id, this.scanId).subscribe((data:any) => {
          if(data.status)
          {
            let controlArray = this.ScanUpdateForm.get('receivedAmtResources') as FormArray;
            controlArray.clear();
            data.data.forEach((element, index) => {
                controlArray.push(this.formBuilder.group({
                  payment_mode: element.payment_mode,
                  payment_screenshot_link: element.payment_screenshot_link,
                  received_amt: element.received_amt,
                  scanPaymentId :element.id
                }));
            });
          }
          this.get_total_receive_amount();
        });
        
    }

    get_rest_aligner(ttype)
    {
      let total_aligners = 0;
      if(ttype == 'upper')
      {
        total_aligners = this.upper_aligners_counter;
      } else {
        total_aligners = this.lower_aligners_counter;
      }
      let aligner_receive = this.ScanProductionStatusForm.get(ttype+'_aligner_received').value;

      let remaining_aligner = total_aligners - aligner_receive;
      if(ttype == 'upper')
      {
        this.ScanProductionStatusForm.patchValue({
          'remaining_upper_aligner' : remaining_aligner
        });
      }
      else 
      {
        this.ScanProductionStatusForm.patchValue({
          'remaining_lower_aligner' : remaining_aligner
        });
      }
    }

    getHospitalAddress()
    {
      let hospital_id = this.ScanForm.get('hospital_id').value;
      this.dentalapi.getHospitalAddress(hospital_id).subscribe((data: any) => {
        if (data.status) {
          this.clinic_address = "<b>Clinic Address:</b> &nbsp;"+data.data.address;
        } else {
          this.clinic_address = "";
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }

    getLeadScanFormData(){
      this.dataLoaded = false;
      this.dentalapi.getLeadScanData(this.lead_id,this.scanId).subscribe((data:LeadScanResponse) => {
        if(data.status){
          
          if(data.lead)
          {
              this.dataLoaded = true;
              this.ScanForm.patchValue({
                  'patient_name':data.lead.lead_name,
                  'mobile':data.lead.mobile,
                  'patient_age':data.lead.patient_age,
                  'gender':data.lead.gender,
                  'treatment_id':data.lead.treatment_id,
                  'user_id':data.lead.user_id,
                  'fb_lead_id':data.lead.fb_lead_id,
                  'lead_source':data.lead.lead_source,
                  'lead_created_at':data.lead.lead_created_at
              });
          }
          if(data.scanbookData.id){
            this.scanId = data.scanbookData.id; 
            var clinic_type = data.scanbookData.clinic_type;
            if(clinic_type == null)
            {
              this.getHospitalOrClinic(1)
            } else {
              this.getHospitalOrClinic(clinic_type)
            }
            this.ScanForm.patchValue({
              'email':data.scanbookData.email,
              'status':data.scanbookData.status,
              'scan_machine':data.scanbookData.machine_id,
              'scan_pro_user_id':data.scanbookData.scan_pro_userid,
              'appointment_type':data.scanbookData.appointment_type,
              'appointment_datetime':data.scanbookData.appointment_datetime ? new Date(data.scanbookData.appointment_datetime*1000) : '',
              'visit_type':data.scanbookData.visit_type,
              'reference_type':data.scanbookData.reference_type,
              'google_location':data.scanbookData.google_location,
              'scan_address':data.scanbookData.address,
              'clinic_type':data.scanbookData.clinic_type == null ? 1 : data.scanbookData.clinic_type,
              'hospital_id':data.scanbookData.hospital_id,
              'time_slots':data.scanbookData.time_slots,
              
            }); 
            if(data.scanbookData.hospital_id)
            {
              this.getHospitalAddress();
            }
            this.getTimeslots();
            if(data.scanbookData.scan_status == 1) {
              this.addRemoveValidator(1,1);
              this.generate_plan_counter = true;
              
              if(data.scanbookData.share_type_arr) {
                this.share_type_array = data.scanbookData.share_type_arr;
              } else {
                this.share_type_array = [];
              }
  
              this.total_generate_plan_docs = data.scanbookData.total_generate_plan_docs;
              this.aligner_duration_counter = data.scanbookData.aligners_duration;
              this.upper_aligners_counter = data.scanbookData.upper_aligners;
              this.lower_aligners_counter = data.scanbookData.lower_aligners;
              this.mail_send_btn_plan_generate = data.scanbookData.plan_generate;
              this.patient_share_on = data.scanbookData.share_with_patient_on;
            
              this.ScanPlanForm.patchValue({
                'plan_generate':data.scanbookData.plan_generate ? data.scanbookData.plan_generate.toString() : '',
                'aligners_duration':data.scanbookData.aligners_duration,
                'upper_aligners':data.scanbookData.upper_aligners,
                'lower_aligners':data.scanbookData.lower_aligners,
                'pre_treatment_procedure': (data.scanbookData.pre_treatment_procedure == 'true') ? true : '',
                'pre_delivery_procedure': data.scanbookData.pre_delivery_procedure == 'true' ? true : '',
                'pre_treatment_procedure_remarks':data.scanbookData.pre_treatment_procedure_remarks,
                'pre_delivery_procedure_remarks':data.scanbookData.pre_delivery_procedure_remarks,
                'other_information':data.scanbookData.other_information,
                'upper_aligners_725' :data.scanbookData.snazzy_upper_aligners,
                'lower_aligners_725':data.scanbookData.snazzy_lower_aligners,
                'pre_treatment_procedure_remarks_725' :data.scanbookData.snazzy_treatment_procedure_remarks,
                'other_information_725':data.scanbookData.snazzy_other_information,
                'upper_aligners_726' :data.scanbookData.ods_upper_aligners,
                'lower_aligners_726' :data.scanbookData.ods_lower_aligners,
                'pre_treatment_procedure_remarks_726' :data.scanbookData.ods_treatment_procedure_remarks,
                'other_information_726':data.scanbookData.ods_other_information
              });


            }else{
              this.addRemoveValidator(1,2);
              this.generate_plan_counter = false;
            }
            
            if(data.scanbookData.scan_status == 1 && data.scanbookData.share_with_patient) {
              this.production_status_tab = true;
              this.ScanProductionStatusForm.patchValue({
                'approval_received':data.scanbookData.approval_received,
                'approval_received_reason':data.scanbookData.approval_received_reason,
                'send_to_production':data.scanbookData.send_to_production,
                'send_to_production_on':data.scanbookData.send_to_production_on,
                'aligner_received':data.scanbookData.aligner_received,
                'aligner_received_on':data.scanbookData.aligner_received_on,
                'clinic_visit_required':data.scanbookData.clinic_visit_required,
                'clinic_visit_required_on':data.scanbookData.clinic_visit_required_on,
                'clinic_visit_hospital':data.scanbookData.clinic_visit_hospital,
                'aligner_dispatched_date':data.scanbookData.aligner_dispatched_date ? new Date(data.scanbookData.aligner_dispatched_date*1000) : '',
                'aligner_delivery_date':data.scanbookData.aligner_delivery_date ? new Date(data.scanbookData.aligner_delivery_date*1000) : '',
                'approval_received_date':data.scanbookData.approval_received_date ? new Date(data.scanbookData.approval_received_date*1000) : '',
                'tracking_id':data.scanbookData.tracking_id,
                'upper_aligner_received':data.scanbookData.upper_aligner_received,
                'lower_aligner_received':data.scanbookData.lower_aligner_received,
                'retainer_received':data.scanbookData.retainer_received,
                'retainer_dispatched':data.scanbookData.retainer_dispatched,
                'pre_treatment_complete_date':data.scanbookData.pre_treatment_complete ? new Date(data.scanbookData.pre_treatment_complete*1000) : '',
                'aligner_usages_started_date':data.scanbookData.aligner_usages_started ? new Date(data.scanbookData.aligner_usages_started*1000) : ''
              });
              this.get_rest_aligner('upper');
              this.get_rest_aligner('lower');
            } else {
              this.production_status_tab = false;
            }
            
          }
          if(data.scanPayment){
            this.fetchReceivedAmountData();
            this.scanStatusPaymentId = data.scanPayment.scan_book_id;
            this.getSubRCA(data.scanbookData.rca);
            this.ScanUpdateForm.patchValue({
              'patient_category':data.scanbookData.patient_category,
              'offer_given':data.scanbookData.offer_given,
              'google_form_link':data.scanbookData.google_form_link,
              'orthodontist_user_id':data.scanbookData.dental_labs_id,
              'scan_done_date':data.scanbookData.scan_done_date ? new Date(data.scanbookData.scan_done_date*1000) : '',
              'document_upload_date':data.scanbookData.document_upload_date ? new Date(data.scanbookData.document_upload_date*1000) : '',
              'scan_status':data.scanbookData.scan_status,
              'no_scan_reason':data.scanbookData.scan_status_comments,
              'payment_status':data.scanbookData.payment_status,
              'no_payment_reason':data.scanbookData.payment_status_comments,
              'rca':data.scanbookData.rca,
              'sub_rca':data.scanbookData.sub_rca,
              'payment_mode':data.scanPayment.payment_mode,
              'convert_type':data.scanbookData.convert_type,
              'any_other_dental':data.scanbookData.any_other_dental,
              'transaction_id':data.scanbookData.transaction_id,
              'billed_amt':data.scanPayment.billed_amt,
              'package_price':data.scanbookData.package_price ? data.scanbookData.package_price : data.scanPayment.billed_amt,
              'discount_price':data.scanbookData.discount_price ? data.scanbookData.discount_price : 0,
              'payment_datetime':data.scanPayment.payment_datetime ? data.scanPayment.payment_datetime : '',
            });
            this.calculate_gst();
            this.google_link_share_on = data.scanbookData.link_send_on;
          } else {
            this.getSubRCA(data.scanbookData.rca);
            this.ScanUpdateForm.patchValue({
              'patient_category':data.scanbookData.patient_category,
              'offer_given':data.scanbookData.offer_given,
              'google_form_link':data.scanbookData.google_form_link,
              'orthodontist_user_id':data.scanbookData.dental_labs_id,
              'scan_done_date':data.scanbookData.scan_done_date ? new Date(data.scanbookData.scan_done_date*1000) : '',
              'document_upload_date':data.scanbookData.document_upload_date ? new Date(data.scanbookData.document_upload_date*1000) : '',
              'scan_status':data.scanbookData.scan_status,
              'no_scan_reason':data.scanbookData.scan_status_comments,
              'rca':data.scanbookData.rca,
              'sub_rca':data.scanbookData.sub_rca,
              'payment_status':data.scanbookData.payment_status,
              'no_payment_reason':data.scanbookData.payment_status_comments,
              'package_price':data.scanbookData.package_price ? data.scanbookData.package_price : '0',
              'discount_price':data.scanbookData.discount_price ? data.scanbookData.discount_price : '0',
              'convert_type':data.scanbookData.convert_type ? data.scanbookData.convert_type : '',
              'any_other_dental':data.scanbookData.any_other_dental ? data.scanbookData.any_other_dental : '',
              'transaction_id':data.scanbookData.transaction_id ? data.scanbookData.transaction_id : '',
            });
            this.calculate_gst_with_package_price();
            this.google_link_share_on = data.scanbookData.link_send_on;
          }



          this.allUploads = data.uploadedDocs;
          // for Re-Scan //
            let pageUrl= this.route.routeConfig.path;
            if(pageUrl.includes('re-scan')){
              // Assign Scan Id to 0 for added new re-scan data //
              this.scanId = '0';
              this.allUploads = [];
              this.ScanForm.patchValue({
                'status': '',
                'scan_machine' :'',
                'scan_pro_user_id':'',
                'appointment_type': 2,
                'appointment_datetime':'',
                'visit_type':'',
                'reference_type':'',
                'google_location':'',
                'scan_address':'',
                'hospital_id':''
              }); 
              // Reset Scan Payment Form Data //
              this.ScanUpdateForm.patchValue({
                'patient_category':'',
                'offer_given':'',
                'orthodontist_user_id':'',
                'google_form_link':'',
                'scan_done_date':'',
                'document_upload_date':'',
                'scan_status':'',
                'no_scan_reason':'',
                'payment_status':'',
                'no_payment_reason':'',
                'convert_type' : '',
                'any_other_dental' : '',
                'transaction_id' : '',
                'rca':'',
                'sub_rca':'',
                'payment_mode':'',
                'billed_amt':'',
                'package_price':'',
                'discount_price':'',
                'payment_datetime':'',
                'receivedAmtResources': this.formBuilder.array([]) ,
              });
              // Reset Scan Payment Form Data //
              this.ScanPlanForm.patchValue({
                'plan_generate':'',
                'aligners_duration':'',
                'upper_aligners':'',
                'lower_aligners':'',
                'pre_treatment_procedure_remarks':'',
                'pre_delivery_procedure_remarks':'',
                'other_information':'',
                'upper_aligners_725' :'',
                'lower_aligners_725' :'',
                'pre_treatment_procedure_remarks_725' :'',
                'other_information_725':'',
                'upper_aligners_726' :'',
                'lower_aligners_726' :'',
                'pre_treatment_procedure_remarks_726' :'',
                'other_information_726':''
              });

              // Reset Production Status Form Data //
              this.ScanProductionStatusForm.patchValue({
                'approval_received':'',
                'approval_received_reason':'',
                'send_to_production':'',
                'send_to_production_on':'',
                'aligner_received':'',
                'aligner_received_on':'',
                'clinic_visit_required':'',
                'clinic_visit_required_on':'',
                'clinic_visit_hospital':'',
                'aligner_dispatched_date':'',
                'aligner_delivery_date':'',
                'approval_received_date':'',
                'tracking_id':'',
                'upper_aligner_received':'',
                'lower_aligner_received':'',
                'retainer_received':'',
                'retainer_dispatched':'',
                'remaining_upper_aligner':'',
                'remaining_lower_aligner':'',
                'pre_treatment_complete_date':'',
                'aligner_usages_started_date':''
              });
            }
        }else{
          this.dataLoaded = true;
          this.sharedapi.presentToast(data.msg);
          this.router.navigate(['/sheetview']);
        }
        
      }, error => {
            this.dataLoaded = true;
            this.sharedapi.checkError(error);
      });
    }
    getPaymentMode(mode){
      let paytype;
      switch(mode)
      {
          case 'Cash':
          paytype = 1;
          break;
          case 'EMI':
          paytype = 4;
          break;
          case 'Cheque':
          paytype = 5;
          break;
          case 'Razorpay':
          paytype = 6;
          break;
          case 'Net Banking':
          paytype = 7;
          break;
      }
        return paytype;
    }

    
    async getMachine()
    {
        await this.dentalapi.getMachines().subscribe((data:MachineResponse) => {
            if(data.status)
            {
                this.machineList = data.data;
            }else{
                this.machineList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTimeslots()
    {
      this.loading = true;
      let appointment_date = this.ScanForm.get('appointment_datetime').value;
      appointment_date = formatDate(appointment_date, 'yyyy-MM-dd', 'en-US');
      await this.dentalapi.getTimeslots(this.lead_id, appointment_date, this.scanId).subscribe((data:any) => {
        this.loading = false;
        if(data.status)
        {
          this.timeslotsList = data.data;
        }else{
            this.timeslotsList = [];
        }
      }, error => {
            this.sharedapi.checkError(error);
      });
    }

    async getTimeslotsChangeBox()
    {
      this.loading = true;
      this.ScanForm.patchValue({
        'time_slots':'',
      });
      let appointment_date = this.ScanForm.get('appointment_datetime').value;
      appointment_date = formatDate(appointment_date, 'yyyy-MM-dd', 'en-US');
      await this.dentalapi.getTimeslots(this.lead_id, appointment_date, this.scanId).subscribe((data:any) => {
        this.loading = false;
        if(data.status)
        {
          this.timeslotsList = data.data;
        }else{
            this.timeslotsList = [];
        }
      }, error => {
            this.sharedapi.checkError(error);
      });
    }

    async getScanProUser()
    {
        await this.dentalapi.getscanprouser().subscribe((data:UserResponse) => {
            if(data.status)
            {
                this.scanProUser = data.data;
                
            }else{
                this.scanProUser = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getHospital()
    {
        await this.leadapi.gethospitals().subscribe((data:HospitalResponse) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:TreatmentResponse) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getbds()
    {
        this.leadapi.getbds().subscribe((data:UserResponse) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async share_google_links(share_id) {
      this.mail_sending=true;
      await this.dentalapi.shareGoogleLinks(share_id).subscribe((data:any) => {
        this.mail_sending=false;
        if(data.status) {
          this.google_link_share_on = data.link_send_on;
        } else {
          this.google_link_share_on = 0;
        }
        this.sharedapi.presentToast(data.msg);
      }, error => {
        this.mail_sending=false;
        this.sharedapi.checkError(error);
      });
    }

    async plan_share_with_patient(share_id) {
      if(this.share_type_select != "" && this.share_type_select != undefined)
      {   
        this.mail_sending=true;
        await this.dentalapi.planShareWithPatient(share_id,this.share_type_select).subscribe((data:any) => {
          this.mail_sending=false;
          if(data.status) {
            this.production_status_tab = true;
            this.patient_share_on = data.share_with_patient_on;
            this.share_type_select = '';
          } else {
            this.production_status_tab = false;
            this.patient_share_on = 0;
          }
          this.sharedapi.presentToast(data.msg);
        }, error => {
          this.mail_sending=false;
            this.sharedapi.checkError(error);
        });
      } else{
        this.sharedapi.presentToast('Please select Share Type');
      }
    }

    removeFile(fileId)
    {
        this.fileDeleting = true;
        this.fileDeletingLoader = true;
        this.dentalapi.deleteScanFiles(fileId).subscribe((data:any) => {
            this.fileDeleting = false;
            this.fileDeletingLoader = false;
            if(data.status)
            {
                this.getLeadScanFormData();
            }else{
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    receivedAmtResources() : FormArray {
      return this.ScanUpdateForm.get("receivedAmtResources") as FormArray
    }
    
    addMoreReceivedAmount() {
      this.receivedAmtResources().push(this.newQuantity());
      let getIndex= this.ScanUpdateForm.controls["receivedAmtResources"].value.length-1;
      this.disableSelect[getIndex]=true;
    }

    newQuantity(): FormGroup 
    {
      return this.formBuilder.group({
        payment_mode: '',
        received_amt: '',
        payment_screenshot_link: '',
        scanPaymentId: '',
        payment_otp: ''
      })
      
    }

    removeQuantity(i:number, scan_payment_id) {
      if(scan_payment_id) {
        this.dentalapi.amountReceivedDeleted(scan_payment_id).subscribe((data:any) => {
          this.getLeadScanFormData();
        }, error => {
          this.sharedapi.checkError(error);
        });
      } else {
        this.receivedAmtResources().removeAt(i);
      }
      this.get_total_receive_amount();
    }

    get_total_receive_amount() {
      let controlArray = <FormArray>this.ScanUpdateForm.controls["receivedAmtResources"];
      var total_amt = this.ScanUpdateForm.get('billed_amt').value;
      var totalreceiveamt=0;
      if(controlArray.value.length){
        controlArray.value.forEach(element => {
          totalreceiveamt+=parseInt(element.received_amt);
        }); 
      }
      this.balance_amt = total_amt - totalreceiveamt;
      if(this.balance_amt) {
        this.ScanUpdateForm.patchValue({
          'balanced_amount' : this.balance_amt.toFixed(2)
        });
      } else {
        this.ScanUpdateForm.patchValue({
          'balanced_amount' : 0
        });
      }
      
    }

    check_otp(index)
    {
      let controlArray = <FormArray>this.ScanUpdateForm.controls["receivedAmtResources"];
      let otp_receive_amount = controlArray.value[index].received_amt;
      let otp_payment_mode = controlArray.value[index].payment_mode;
      let otp_payment_otp = controlArray.value[index].payment_otp;
      if(otp_receive_amount && otp_payment_mode && otp_payment_otp)
      {

      } else {
        this.sharedapi.presentToast("Received Amount, Payment Mode and OTP field is required for payment.");
      }
    }

    sendOTPforCash(index)
    {
      let controlArray = <FormArray>this.ScanUpdateForm.controls["receivedAmtResources"];
      let otp_payment_mode = controlArray.value[index].payment_mode;
      if(otp_payment_mode=='1'){
        this.hideOtpButton[index] = false;
      } else {
        this.hideOtpButton[index] = true;
      }
      
    }

    sendOTPButton(index, event: any)
    {
      let controlArray = <FormArray>this.ScanUpdateForm.controls["receivedAmtResources"];
      let otp_receive_amount = controlArray.value[index].received_amt;
      let otp_payment_mode = controlArray.value[index].payment_mode;
      let otp_mobile = this.ScanForm.get('mobile').value;
      if(otp_receive_amount && otp_payment_mode && otp_mobile)
      {
        event.target.disabled = true;
        this.dentalapi.sendPaymentOTP(otp_mobile, otp_receive_amount, otp_payment_mode, this.lead_id).subscribe((data:any) => {
          this.sharedapi.presentToast(data.msg);
          if(data.status)
          {
            this.hideOtpButton[index] = true;
            this.showresenOtpButton[index] = true;
            this.showotpBox[index] = true;
          }
        }, error => {
          this.sharedapi.checkError(error);
        });

      } else {
        this.sharedapi.presentToast("Received Amount and Payment Mode is required for Send OTP.");
      }
    }

    show_submit_otp_button(type,index)
    {
      if(type=='1'){
        this.showsubmitOtpButton[index] = true;
        this.hideOtpButton[index] = true;
        this.showresenOtpButton[index] = false;
        this.showOtpVerified[index] = false;
      }else{
        this.showsubmitOtpButton[index] = false;
        this.hideOtpButton[index] = false;
        this.showresenOtpButton[index] = true;
        this.showOtpVerified[index] = true;
      }
    }

    submitOTPButton(index)
    {
      let controlArray = <FormArray>this.ScanUpdateForm.controls["receivedAmtResources"];
      let otp_receive_amount = controlArray.value[index].received_amt;
      let otp_payment_mode = controlArray.value[index].payment_mode;
      let otp_payment_otp = controlArray.value[index].payment_otp;
      let otp_mobile = this.ScanForm.get('mobile').value;
      if(otp_receive_amount && otp_payment_mode && otp_mobile && otp_payment_otp)
      {
        this.dentalapi.verifyOtp(otp_mobile, otp_receive_amount, otp_payment_mode, otp_payment_otp, this.lead_id).subscribe((data:any) => {
          this.sharedapi.presentToast(data.msg);
          if(data.status)
          {
            this.showsubmitOtpButton[index] = false;
            this.showOtpVerified[index] = true;
            this.showresenOtpButton[index] = false;
          } else {
            this.showsubmitOtpButton[index] = false;
            this.showresenOtpButton[index] = true;
            this.showOtpVerified[index] = false;
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
      } else {
        this.sharedapi.presentToast("Received Amount, Payment Mode and OTP is required for Submit OTP.");
      }
    }

    openHistoryPopup()
    {
        this.history_loading = true;this.history_loaded = false;
        this.dentalapi.getFullScanBookHistory(this.lead_id, this.scanId).subscribe((data:any) => {
            this.history_loading = false;
            this.history_loaded = true;
            if(data.status)
            {
                this.updatedLodData = data.data;
            }else{
                this.updatedLodData = [];
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
        $('#myHistoryModal').modal();
    }

    closeHistoryPopup()
    {
      $('#myHistoryModal').modal('hide');
    }
    async getOrthodontistUser()
    {
      this.dentalapi.getOrthodntistUser().subscribe((data:any) => {
      if(data.status)
      {
        this.ortho_user = data.data;
        this.ortho_user_copy = this.ortho_user;
      }else{
        this.ortho_user = [];
        }
      }, error => {
          this.sharedapi.checkError(error);
       });
    }        

    async getHospitalOrClinic(type)
    {
        let qString = 'type='+type;
        this.clinic_address = "";
        await this.leadapi.getHospitalOrClinic(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
                this.type_Clinic=false;
            }else{
                this.hospitals = [];
                this.type_Clinic=false;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getOdsScanDocs() {
      this.dataLoaded = false;
      this.scanId = this.route.snapshot.paramMap.get("scan_id");
      this.plan_doc_loading=true;

      let qString = 'filter_plan_lab_list='+this.filter_plan_lab_list+'&filter_plan_appt_type='+this.filter_plan_appt_type+'&filter_plan_share_type='+this.filter_plan_share_type;

      await this.dentalapi.getUpdateOdsData(this.scanId, qString).subscribe((response: any) => {
        this.plan_doc_loading=false;
        if (response.status) {
          this.dataLoaded = true;
          this.new_scan = response.new_scan;
          this.trust_align = response.trust_align;
          this.ods_documents = response.scanBookOdsDocs;
        }else{
          this.dataLoaded = true;
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }

    resetOdsScanDocsFilter()
    {
      this.filter_plan_lab_list = "";
      this.filter_plan_appt_type = "";
      this.filter_plan_share_type = "";
      this.getOdsScanDocs();
    }

    removeOdsDocs(doc_id) {
      this.odsDocsDeletingLoader = true;
      this.dentalapi.deleteplanFiles(doc_id).subscribe((data: any) => {
        this.odsDocsDeletingLoader = false;
        if (data.status) {
          this.getOdsScanDocs();
        } else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }

  validate_type(type_id)
  {
    this.loading = true;
    if(this.send_download_type && this.send_download_lab_list && this.send_download_type)
    {
      this.type_validator_drop = false;
      if(type_id==1)
      {
        this.loading = false;
        /****Code for Download PDF****** */
        this.dentalapi.download_plan_pdf(this.send_download_appointment_type, this.scanId, this.send_download_lab_list, this.send_download_type);
      } 
      else if (type_id==2)
      {
        this.email_loading = true;
        /****Code for Send PDF Plan through HTML****** */
        this.dentalapi.sendPdfPlanEmail(this.send_download_appointment_type, this.scanId, this.send_download_lab_list, this.send_download_type).subscribe((data: any) => {
          this.loading = false;
          this.email_loading = false;
          this.sharedapi.presentToast(data.msg);
        }, error => {
          this.sharedapi.checkError(error);
        });
      }
    }
    else
    {
      this.loading = false;
      this.type_validator_drop = true;
    }
    
  }


  validate_payment_recipt_type(type_id)
  {
    this.payment_loading = true;
    if(type_id==1)
    {
      this.payment_loading = false;
      /****Code for Download PDF****** */
      this.dentalapi.download_payment_receipt(this.scanId);
    }
    else if (type_id==2)
    {
      this.payment_email_loading = true;
      /****Code for Send PDF Plan through HTML****** */
      this.dentalapi.sendPaymentReceipt(this.scanId).subscribe((data: any) => {
        this.payment_loading = false;
        this.payment_email_loading = false;
        this.sharedapi.presentToast(data.msg);
      }, error => {
        this.sharedapi.checkError(error);
      });
    } 
  }

  get_appointment_type_of_lab()
  {
    this.appointment_type_lab_arr = [];
    this.scan_type_lab_arr = [];
    this.send_download_appointment_type = "";
    this.send_download_type = "";
    if(this.send_download_lab_list)
    {
      this.dentalapi.getAppointmentTypeOfLab(this.send_download_lab_list, this.scanId).subscribe((data: any) => {
        if(data.status)
        {
          this.appointment_type_lab_arr = data.data;
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
  }

  get_scan_type_of_lab()
  {
    this.scan_type_lab_arr = [];
    this.send_download_type = "";
    if(this.send_download_appointment_type)
    {
      this.dentalapi.getScantypeOfLab(this.send_download_lab_list,this.send_download_appointment_type, this.scanId).subscribe((data: any) => {
        if(data.status)
        {
          this.scan_type_lab_arr = data.data;
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
  }

}
